module.exports = __webpack_public_path__ + "media/images/how_it_works/step-1-cd5f1296561fe6c03afeae281e2f4e78.svg";